export default __webpack_public_path__ + "static/media/kitchen3-afterD-1440w.0ac3b948.png";